<template>
  <div v-if="text" class="text-lg lg:text-xl" :class="paragraphClassList">
    <div
      :class="{
        'col-span-4 sm:col-span-6 md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3':
          !parentType,
      }"
    >
      <div
        v-if="text"
        v-blokkli-editable:field_text
        class="ck-content hyphens-auto"
        :class="{
          'text-lg md:text-xl': parentType == 'teaser_list',
          'mt-2 md:mt-3': parentType,
          'text-wrap': !parentType,
        }"
        v-html="text"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { options, parentType } = defineBlokkli({
  bundle: 'text',
  editor: {
    addBehaviour: 'no-form',
    editTitle: (el) => el.textContent,
    getDraggableElement: (el) => el.querySelector('.ck-content'),
    determineVisibleOptions: (ctx) => {
      const options = []
      if (!ctx.parentType) {
        options.push('spacing')
      }
      return options
    },
  },
  globalOptions: ['spacing'],
})

defineProps<{
  text?: string
}>()

const paragraphClassList = computed(() => {
  if (parentType.value === 'teaser_list') {
    return ['mb-5 mt-5 !p-0 max-w-[800px]']
  }

  if (parentType.value === 'accordeon') {
    return ['mb-5']
  }

  const classList = []

  if (options.value.spacing === 'small') {
    classList.push('pt-6', 'lg:pt-10')
  } else if (options.value.spacing === 'large') {
    classList.push('pt-12', 'lg:pt-20')
  }

  if (!parentType.value) {
    classList.push('grid-container')
  }

  return classList
})
</script>
